import api from "@/services/api";
import { get } from "lodash";

function buildBaseUrl(rootState) {
  const label =
    localStorage.getItem("label") ||
    get(rootState, "company.company.label") ||
    "";
  return `/api/v1/talent/${label}/user/talent/presentation`;
}

export default {
  async fetch({ commit, rootState }) {
    commit("SET_LOADING", true);
    try {
      const { data } = await api.get(buildBaseUrl(rootState));
      const payload = (data && data.data) || {};
      commit("SET_AUDIO", payload.audio || null);
      commit("SET_VIDEO", payload.video || null);
    } catch (error) {
      console.error(error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async saveAudio({ commit, rootState }, file) {
    const fd = new FormData();
    fd.append("file", file, file.name || "presentation.webm");

    const { data } = await api.post(`${buildBaseUrl(rootState)}/audio`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    commit("SET_AUDIO", get(data, "data", null));
    return get(data, "data", null);
  },

  async deleteAudio({ commit, rootState }) {
    await api.delete(`${buildBaseUrl(rootState)}/audio`);
    commit("SET_AUDIO", null);
  },

  async saveVideo({ commit, rootState }, url) {
    const { data } = await api.post(`${buildBaseUrl(rootState)}/video`, {
      url,
    });
    commit("SET_VIDEO", get(data, "data", null));
    return get(data, "data", null);
  },

  async deleteVideo({ commit, rootState }) {
    await api.delete(`${buildBaseUrl(rootState)}/video`);
    commit("SET_VIDEO", null);
  },

  clear({ commit }) {
    commit("CLEAR");
  },
};
